import ModalController from '../modal_controller.js'

import '../../entrypoints/modules/semantic-ui-dropdown'
import 'semantic-ui-transition/transition.min.js'
import 'semantic-ui-transition/transition.min.css'
import 'semantic-ui-api/api.js'
import 'semantic-ui-search/search.min.js'
import 'semantic-ui-form/form.min.js'
import fetchWithHandlingLoginRedirect from '../../modules/utils/fetchWithHandlingLoginRedirect'
import generateApiKey from '../../utils/generate_api_key'
import { trans, API_KEY_SAVED_SUCCESSFULLY, API_KEY_DELETED, API_KEY_DISABLED } from '../../translator'

export default class extends ModalController {
  static targets = ['menu', 'nameField', 'tokenField', 'formWrapper', 'form', 'message']
  url = null

  connect () {
    super.connect()
  }

  async openModal (event) {
    try {
      this.url = event.params.url
      const response = await fetchWithHandlingLoginRedirect(this.url)
      this.formWrapperTarget.innerHTML = await response.text()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
    }

    super.openModal()
    $('.ui.checkbox').checkbox()
    $('.ui.dropdown').dropdown()
  }

  async delete (event) {
    event.preventDefault()
    try {
      const response = await fetchWithHandlingLoginRedirect(event.params.url)

      if (response.status === 204) {
        this.dispatch('submitted')

        this.messageTarget.innerHTML = trans(API_KEY_DELETED, {}, 'settings')
        this.messageTarget.classList.add('alert-danger')
        this.messageTarget.classList.remove('d-none')

        this.messageTarget.style.display = 'block'

        setTimeout(() => {
          this.messageTarget.innerHTML = ''
          this.messageTarget.classList.remove('alert-success')
          this.messageTarget.classList.add('d-none')

          this.messageTarget.style.display = 'none'
        }, 5000)
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
    }
  }

  async disable (event) {
    event.preventDefault()
    try {
      const response = await fetchWithHandlingLoginRedirect(event.params.url)

      if (response.status === 200) {
        this.dispatch('submitted')

        this.messageTarget.innerHTML = trans(API_KEY_DISABLED, {}, 'settings')
        this.messageTarget.classList.add('alert-danger')
        this.messageTarget.classList.remove('d-none')

        this.messageTarget.style.display = 'block'

        setTimeout(() => {
          this.messageTarget.innerHTML = ''
          this.messageTarget.classList.remove('alert-success')
          this.messageTarget.classList.add('d-none')

          this.messageTarget.style.display = 'none'
        }, 5000)
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
    }
  }

  async submit (event) {
    event.preventDefault()

    const formData = new FormData(this.formTarget)

    try {
      const response = await fetchWithHandlingLoginRedirect(this.url, {
        method: 'POST', body: formData
      })

      if (response.status === 200) {
        this.dispatch('submitted')

        this.messageTarget.innerHTML = trans(API_KEY_SAVED_SUCCESSFULLY, {}, 'settings')
        this.messageTarget.classList.add('alert-success')
        this.messageTarget.classList.remove('d-none')

        this.messageTarget.style.display = 'block'

        setTimeout(() => {
          this.messageTarget.innerHTML = ''
          this.messageTarget.classList.remove('alert-success')
          this.messageTarget.classList.add('d-none')

          this.messageTarget.style.display = 'none'
        }, 5000)

        this.closeModal()
      }
    } catch (e) {
      this.formWrapperTarget.innerHTML = await e.text()
      $('.ui.checkbox').checkbox()
      $('.ui.dropdown').dropdown()
    }
    // handle backend errors or close modal, inform user and refresh the page with api keys
  }

  generateApiKey () {
    this.tokenFieldTarget.value = generateApiKey()
  }
}
